import { z } from "zod";

import { VoiceLanguage } from "@/shared/voice-language";

export const appointmentSmsPreferencesSchema = z.strictObject({
  smsDeclined: z.literal(true).optional(),
  smsLanguage: z.enum(VoiceLanguage).optional(),
});
export type AppointmentSmsPreferences = z.infer<typeof appointmentSmsPreferencesSchema>;

/** Whether the backend queued the appointment text that follows a completed Voice appointment change. */
export enum AppointmentSmsStatus {
  Queued = "queued",
  Unavailable = "unavailable",
  Unknown = "unknown",
}

// A status Voice does not know yet must not turn a completed appointment change into an uncertain one.
export const appointmentSmsStatusSchema = z.enum(AppointmentSmsStatus).optional().catch(AppointmentSmsStatus.Unknown);
